module.exports = __webpack_public_path__ + "img/icon1.afe9d6a9.png";